import { render, staticRenderFns } from "./Hcaptcha.vue?vue&type=template&id=021563e4&"
import script from "./Hcaptcha.vue?vue&type=script&lang=js&"
export * from "./Hcaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports